import { render, staticRenderFns } from "./ServiceContent.vue?vue&type=template&id=e7b35fa2&scoped=true"
import script from "./ServiceContent.vue?vue&type=script&lang=js"
export * from "./ServiceContent.vue?vue&type=script&lang=js"
import style0 from "./ServiceContent.vue?vue&type=style&index=0&id=e7b35fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b35fa2",
  null
  
)

export default component.exports